import { makeAutoObservable } from 'mobx';

import { AnalyticDimensions } from '@/analytics/types';
import useStore from '@/common/hooks/useStore';
import { ProductEntity } from '@/product/types';

import { extractProductAnalyticDimensions } from '../helpers/extractProductAnalyticDimensions';
import Analytics, { DEFAULT_CATEGORY } from '../services/Analytics';

export default class AnalyticsStore {
  category: string = DEFAULT_CATEGORY;

  changeCategory = (category: string) => {
    this.category = category;
  };

  sendEventWithContext = (eventName: string, dimensions: AnalyticDimensions = {}) => {
    Analytics.sendEvent(this.category, eventName, dimensions);
  };

  sendEventWithProductAsDimensions = (eventName: string, product?: ProductEntity) => {
    const dimensions = extractProductAnalyticDimensions(product);

    Analytics.sendEvent(this.category, eventName, dimensions);
  };

  sendPageView = (page: string, dimensions: AnalyticDimensions = {}) => {
    Analytics.sendPageview({ page: page }, dimensions);
  };

  constructor() {
    makeAutoObservable(this, {
      sendEventWithContext: false,
      sendEventWithProductAsDimensions: false,
      sendPageView: false,
    });
  }
}

export const useAnalyticsStore = () => useStore(AnalyticsStore);

export const analyticsStore = new AnalyticsStore();
